import { ErrorIcon } from "components/ui/icons/iaAgent/ErrorIcon"
import style from "./FailedStreamingResponseMessage.module.scss"

const { failedResponseMessage } = style

export const FailedStreamingResponseMessage = () => {
	return (
		<div className={failedResponseMessage}>
			<ErrorIcon />
			<p>A streaming response error occurred. Try again later or check your network connection.</p>
		</div>
	)
}
